import CasterDataEntry from "../../pages/caster/data-entry";
import CasterProcesses from "../../pages/caster/processes";
import StrandLossesManager from "../../pages/caster/strand-losses-manager";
import TorchesDataEntry from "../../pages/caster/torches-data-entry";
import CasterMold from "../../pages/eqp/caster/mold";
import ProductionReport from "../../pages/production-report";
import { RouteConfig } from "./types";

// Define Caster routes with flat structure
export const casterRoutes: RouteConfig[] = [
  {
    path: "/caster-data-entry",
    element: <CasterDataEntry />,
    permission: "ui.navbar.caster.data-entry",
  },
  {
    path: "/caster-data-entry/:processId",
    element: <CasterDataEntry />,
    permission: "ui.navbar.caster.data-entry",
  },
  {
    path: "/caster-torches",
    element: <TorchesDataEntry />,
    permission: "ui.navbar.caster.torches",
  },
  {
    path: "/caster-torches/:processId",
    element: <TorchesDataEntry />,
    permission: "ui.navbar.caster.torches",
  },
  {
    path: "/caster-processes",
    element: <CasterProcesses />,
    permission: "ui.navbar.caster.processes",
  },
  {
    path: "/caster-processes/:shiftId",
    element: <CasterProcesses />,
    permission: "ui.navbar.caster.processes",
  },
  {
    path: "/production-report",
    element: <ProductionReport />,
    permission: "ui.navbar.caster.processes",
  },
  {
    path: "/strand-losses-manager",
    element: <StrandLossesManager />,
    permission: "ui.navbar.caster.strand-losses-manager",
  },
  {
    path: "/strand-losses-manager/:shiftId",
    element: <StrandLossesManager />,
    permission: "ui.navbar.caster.strand-losses-manager",
  },
  {
    path: "/caster-mold",
    element: <CasterMold />,
    permission: "ui.navbar.caster.mold",
  },
];
